// extracted by mini-css-extract-plugin
export default {"page":"Impact_page__KlqUP"};